// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-row-module__Row--SAFjw{height:71px;transition:all .25s ease;transition-property:background-color,box-shadow}`, "",{"version":3,"sources":["webpack://./src/components/design/migrated/Table/table-row.module.scss"],"names":[],"mappings":"AAeA,8BACE,WAZiB,CAajB,wBAAA,CACA,+CAAA","sourcesContent":["@use '../Icon/animations' as *;\n@use '../Icon/colors' as *;\n@use '../Icon/shadows' as *;\n\n$table-row-height: 71px;\n$hover-color: $brand-superlightorange;\n\n$sort-cell-color: $background-light;\n$sort-hover-cell-color: $brand-lightorange;\n\n@mixin highlight {\n  background-color: $hover-color;\n  box-shadow: inset 3px 0px 0px $brand-brightorange;\n}\n\n.Row {\n  height: $table-row-height;\n  transition: all $transition-default;\n  transition-property: background-color, box-shadow;\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `#cf4800`;
export { _1 as "brand-darkorange" };
var _2 = `#e55a00`;
export { _2 as "brand-brightorange" };
var _3 = `#fdf6f2`;
export { _3 as "brand-superlightorange" };
var _4 = `#414752`;
export { _4 as "grey-800" };
var _5 = `#5c626e`;
export { _5 as "grey-700" };
var _6 = `#6f7582`;
export { _6 as "grey-600" };
var _7 = `#9499a3`;
export { _7 as "grey-500" };
var _8 = `#bbc0c9`;
export { _8 as "grey-400" };
var _9 = `#dadde3`;
export { _9 as "grey-300" };
var _a = `#ebecf0`;
export { _a as "grey-200" };
var _b = `#f5f6f7`;
export { _b as "grey-100" };
export var white = `#fff`;
export var green = `#167922`;
export var red = `#bc1c0e`;
var _c = `#2b4c9b`;
export { _c as "blue-800" };
var _d = `#3456a6`;
export { _d as "blue-700" };
var _e = `#3c60b3`;
export { _e as "blue-600" };
var _f = `#4368bd`;
export { _f as "blue-500" };
var _10 = `#6480c3`;
export { _10 as "blue-400" };
var _11 = `#879bcc`;
export { _11 as "blue-300" };
var _12 = `#afbbdb`;
export { _12 as "blue-200" };
var _13 = `#dbe0eb`;
export { _13 as "blue-100" };
var _14 = `#428a81`;
export { _14 as "petrol-800" };
var _15 = `#4b9a91`;
export { _15 as "petrol-700" };
var _16 = `#4da9a1`;
export { _16 as "petrol-600" };
var _17 = `#54b9b1`;
export { _17 as "petrol-500" };
var _18 = `#63c8c2`;
export { _18 as "petrol-400" };
var _19 = `#81d7d3`;
export { _19 as "petrol-300" };
var _1a = `#b2edeb`;
export { _1a as "petrol-200" };
var _1b = `#e2ffff`;
export { _1b as "petrol-100" };
var _1c = `#97254f`;
export { _1c as "magenta-800" };
var _1d = `#ac2b55`;
export { _1d as "magenta-700" };
var _1e = `#c02d58`;
export { _1e as "magenta-600" };
var _1f = `#d2335f`;
export { _1f as "magenta-500" };
var _20 = `#d44a73`;
export { _20 as "magenta-400" };
var _21 = `#d76789`;
export { _21 as "magenta-300" };
var _22 = `#da91a7`;
export { _22 as "magenta-200" };
var _23 = `#ddbbc5`;
export { _23 as "magenta-100" };
var _24 = `#ee7c24`;
export { _24 as "yellow-800" };
var _25 = `#f58a27`;
export { _25 as "yellow-700" };
var _26 = `#fa9a2a`;
export { _26 as "yellow-600" };
var _27 = `#ffa52f`;
export { _27 as "yellow-500" };
var _28 = `#fdb244`;
export { _28 as "yellow-400" };
var _29 = `#fdc166`;
export { _29 as "yellow-300" };
var _2a = `#fed79a`;
export { _2a as "yellow-200" };
var _2b = `#ffebcc`;
export { _2b as "yellow-100" };
var _2c = `#167922`;
export { _2c as "green-800" };
var _2d = `#24892c`;
export { _2d as "green-700" };
var _2e = `#329d38`;
export { _2e as "green-600" };
var _2f = `#3dad42`;
export { _2f as "green-500" };
var _30 = `#59b75b`;
export { _30 as "green-400" };
var _31 = `#73c375`;
export { _31 as "green-300" };
var _32 = `#98d299`;
export { _32 as "green-200" };
var _33 = `#bde5bd`;
export { _33 as "green-100" };
var _34 = `#8f0001`;
export { _34 as "red-800" };
var _35 = `#9b0009`;
export { _35 as "red-700" };
var _36 = `#ad0e0e`;
export { _36 as "red-600" };
var _37 = `#bc1c0e`;
export { _37 as "red-500" };
var _38 = `#ba302a`;
export { _38 as "red-400" };
var _39 = `#b0504c`;
export { _39 as "red-300" };
var _3a = `#bb7471`;
export { _3a as "red-200" };
var _3b = `#cba6a8`;
export { _3b as "red-100" };
var _3c = `#5c399b`;
export { _3c as "purple-800" };
var _3d = `#673fa2`;
export { _3d as "purple-700" };
var _3e = `#7249ad`;
export { _3e as "purple-600" };
var _3f = `#7b4db3`;
export { _3f as "purple-500" };
var _40 = `#8d69bb`;
export { _40 as "purple-400" };
var _41 = `#a387c8`;
export { _41 as "purple-300" };
var _42 = `#bfb0d4`;
export { _42 as "purple-200" };
var _43 = `#ddd8e4`;
export { _43 as "purple-100" };
var _44 = `#171a1c`;
export { _44 as "ext-grey-800" };
var _45 = `#3b4145`;
export { _45 as "ext-grey-700" };
var _46 = `#535d63`;
export { _46 as "ext-grey-600" };
var _47 = `#6a757c`;
export { _47 as "ext-grey-500" };
var _48 = `#7f888e`;
export { _48 as "ext-grey-400" };
var _49 = `#9fa7ad`;
export { _49 as "ext-grey-300" };
var _4a = `#c0c5c8`;
export { _4a as "ext-grey-200" };
var _4b = `#d6d9dc`;
export { _4b as "ext-grey-100" };
var _4c = `#167922`;
export { _4c as "ui-green" };
var _4d = `#bc1c0e`;
export { _4d as "ui-red" };
var _4e = `#323842`;
export { _4e as "text-heading" };
var _4f = `#414752`;
export { _4f as "text-default" };
var _50 = `#5c626e`;
export { _50 as "text-secondary-interactive" };
var _51 = `#6f7582`;
export { _51 as "text-lighter" };
var _52 = `#9499a3`;
export { _52 as "text-inactive" };
export var stroke = `#bbc0c9`;
var _53 = `#dadde3`;
export { _53 as "stroke-light" };
var _54 = `#6f7582`;
export { _54 as "background-darkest" };
var _55 = `#dadde3`;
export { _55 as "background-dark" };
var _56 = `#ebecf0`;
export { _56 as "background-medium" };
var _57 = `#f5f6f7`;
export { _57 as "background-light" };
var _58 = `#fed79a`;
export { _58 as "color-focus" };
var _59 = `#4368bd`;
export { _59 as "colors-0" };
var _5a = `#54b9b1`;
export { _5a as "colors-1" };
var _5b = `#ffa52f`;
export { _5b as "colors-2" };
var _5c = `#d2335f`;
export { _5c as "colors-3" };
var _5d = `#7b4db3`;
export { _5d as "colors-4" };
var _5e = `#879bcc`;
export { _5e as "colors-5" };
var _5f = `#bfb0d4`;
export { _5f as "colors-6" };
var _60 = `#97254f`;
export { _60 as "colors-7" };
var _61 = `#4da9a1`;
export { _61 as "colors-8" };
var _62 = `#ffebcc`;
export { _62 as "colors-9" };
var _63 = `#fdb244`;
export { _63 as "colors-10" };
var _64 = `#8d69bb`;
export { _64 as "colors-11" };
var _65 = `#afbbdb`;
export { _65 as "colors-12" };
var _66 = `#da91a7`;
export { _66 as "colors-13" };
var _67 = `#81d7d3`;
export { _67 as "colors-14" };
var _68 = `#d44a73`;
export { _68 as "colors-15" };
var _69 = `#5c399b`;
export { _69 as "colors-16" };
var _6a = `#f58a27`;
export { _6a as "colors-17" };
var _6b = `#a387c8`;
export { _6b as "colors-18" };
var _6c = `#428a81`;
export { _6c as "colors-19" };
var _6d = `#fed79a`;
export { _6d as "colors-20" };
var _6e = `#6480c3`;
export { _6e as "colors-21" };
var _6f = `#ddbbc5`;
export { _6f as "colors-22" };
var _70 = `#4b9a91`;
export { _70 as "colors-23" };
var _71 = `#ddd8e4`;
export { _71 as "colors-24" };
var _72 = `#c02d58`;
export { _72 as "colors-25" };
var _73 = `#e2ffff`;
export { _73 as "colors-26" };
var _74 = `#fdc166`;
export { _74 as "colors-27" };
var _75 = `#dbe0eb`;
export { _75 as "colors-28" };
var _76 = `#673fa2`;
export { _76 as "colors-29" };
var _77 = `0px 2px 2px 0px rgba(0,0,0,.1)`;
export { _77 as "shadow-sm" };
var _78 = `0px 4px 2px 0px rgba(0,0,0,.1)`;
export { _78 as "shadow-lg" };
var _79 = `0 0 1px 2px #fed79a`;
export { _79 as "shadow-focus" };
export var Row = `table-row-module__Row--SAFjw`;
export default ___CSS_LOADER_EXPORT___;
